module.exports = __webpack_public_path__ + "static/img/newLogo.7fa1005.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gRDImg/newLogo.png
// module id = 42r7
// module chunks = 1